import { getCurrTest, testToStep } from '../constants';
import { cEl } from '../../../../util';

function TestPage() {
    const { key, questionNum } = getCurrTest();
    const currentTestQuestions = testToStep[key];
    const noneQuestionNum = currentTestQuestions.filter(question => !question.questionText).length;
    const currentQuestion = currentTestQuestions[questionNum];
    const questionContainer = cEl('article');
    questionContainer.classList.add('question-container', `answer-${currentQuestion.answersType}`);

    const question = cEl('div');
    question.classList.add('question');
    question.innerHTML = `
        <div class="question-step">Question ${questionNum + 1 - noneQuestionNum} <span class="question-step-all">/ ${currentTestQuestions.length - noneQuestionNum}</span></div>
        <div class="question-text">${currentQuestion.questionText}</div>    
    `;

    const answerContainer = cEl('div');
    answerContainer.classList.add('answer-container');
    answerContainer.append(
        ...currentQuestion.answers.map(a => Answer({ ...a, multipleSelection: currentQuestion.multipleSelection })),
    );

    questionContainer.append(question, answerContainer);

    return questionContainer;
}

const Answer = ({ key, value, text, score, multipleSelection }) => {
    const answer = cEl('div');
    answer.classList.add('answer');
    answer.dataset.key = key;
    answer.dataset.score = score;
    answer.dataset.value = value;
    answer.innerHTML = text;
    answer.addEventListener('click', e => {
        if (!multipleSelection) {
            document.querySelector('.answer.selected')?.classList.remove('selected');
        }
        const el = e.currentTarget;
        el.classList.toggle('selected');

        const nextButton = document.querySelector('.question-footer .next-button');
        if (nextButton) {
            nextButton.disabled = false;
            nextButton.classList.add('active');
        }
    });
    return answer;
};

export default TestPage;
